<div class="main1">
    <div class="unit">
      <p>Shipper</p>
      <div class="selectUnit">
        <div class="unitSelection">
          <mat-select style="color: #fff;" placeholder="{{selectedUnit.name}}" [(ngModel)]="selectedUnit"
            style="width: 350px;">
            <mat-option *ngFor="let unit of units" (click)="selectUnit(unit)" [value]="unit"
              title="{{unit.parent_name}} - {{unit.name}}">
              {{unit.parent_name}} - {{unit.name}}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="main-section">
      <div class="left">
        <div class="ServiceQuality">
          <p style="font-size: 20px; text-align: center;position: relative; left: 17%;">Service Quality Score</p>
          <div>
            <mat-card class="assign-reject-card">
              <div class="unitSelection1">
                <img src="assets/calendar.svg">
                <mat-select style="color: #fff;" placeholder='{{durationName}}' [(ngModel)]="durationName">
                  <mat-option *ngFor="let dur of durationForAssignReject" (click)="changeDuration(dur)" title="{{dur.name}}">
                    {{dur.name}}
                  </mat-option>
                </mat-select>
              </div>
              <div class="filter" *ngIf="isDate_rangeServiceQuality">
                <div class="label">
                  {{ "REPORTS.from" | translate }} <span><sup class="required" style="color:red;">*</sup></span>
                </div>
                <div class="input">
                  <input type="text" style="width: 100%;border-radius: 5px;border: 1px solid gray;background: #F1F3F8;" class="inputField"
                    placeholder="Date" [(ngModel)]="fromDate" (click)="fromDateInput.open()"
                    [matDatepicker]="fromDateInput" />
                  <mat-datepicker #fromDateInput (closed)="getDateRange()"></mat-datepicker>
                  <span class="material-icons dateIcon" style="position: absolute;left: 90px;top:4px;"> date_range </span>
                </div>
              </div>
              <div class="filter1" *ngIf="isDate_rangeServiceQuality">
                  <div class="label">
                    {{ "REPORTS.to" | translate }} <span><sup class="required" style="color:red;">*</sup></span>
                  </div>
                  <div class="input">
                    <input type="text"  style="width: 100%;border-radius: 5px;border: 1px solid gray;background: #F1F3F8;" class="inputField"
                      placeholder="Date" [(ngModel)]="toDate" (click)="toDateInput.open()" [matDatepicker]="toDateInput" />
                    <mat-datepicker #toDateInput (closed)="getDateRange()"></mat-datepicker>
                    <span class="material-icons dateIcon" style="position: absolute;left: 90px;top:4px;"> date_range </span>
                  </div>
                </div>
              <div style="position: absolute;left: 78%;top: 6%;font-size:large;"><span>{{ "SHIPMENTDETAILS.totalAllocated" | translate }} - {{ totalAllocated }}</span></div>
              <mat-card-content class="assignReject">
                <div class="timecard" style="display: flex;">
                  <div class="acceptancePercentage" style="margin-right: -25px;margin-left: -23px;">
                    <rg-gauge-chart [canvasWidth]="acceptCanvasWidth" [needleValue]="acceptNeedleValue" [centralLabel]="acceptCentralLabel"
                      [options]="acceptOptions" [bottomLabel]="acceptBottomlabel">
                    </rg-gauge-chart>
                    <p class="title2">Acceptance</p>
                    </div>
              <!-- <div class="h-line" style="position:relative; top:140px;border: 1px solid #E5EFF8;"></div> -->
              <div class="rejectPercentage" style="margin-right: -26px;">
                <rg-gauge-chart [canvasWidth]="rejectCanvasWidth" [needleValue]="rejectNeedleValue" [centralLabel]="rejectCentralLabel"
                  [options]="rejectOptions" [bottomLabel]="rejectBottomlabel">
                </rg-gauge-chart>
                <p class="title2">Rejection</p>
                </div>
                <div class="assignPercentage" style="margin-right: -18px;">
                  <rg-gauge-chart [canvasWidth]="assignCanvasWidth" [needleValue]="assignNeedleValue" [centralLabel]="assignCentralLabel"
                    [options]="assignOptions" [bottomLabel]="assignBottomlabel">
                  </rg-gauge-chart>
                  <p class="title1">Assignment</p>
                </div>
                <div class="nonFullfillPercentage"  style="margin-right: -2px;">
                  <rg-gauge-chart [canvasWidth]="nonfullfilledCanvasWidth" [needleValue]="non_fullfilledNeedleValue" [centralLabel]="non_fullfilledCentralLabel"
                    [options]="non_fullfilledOptions" [bottomLabel]="non_fullfilledBottomlabel">
                  </rg-gauge-chart>
                  <p class="title2">Non Assignment</p>
                  </div>
                <div class="FullfillPercentage">
                  <rg-gauge-chart [canvasWidth]="fulfilledCanvasWidth" [needleValue]="fulfilledNeedleValue" [centralLabel]="fulfilledCentralLabel"
                    [options]="fulfilledOptions" [bottomLabel]="fulfilledBottomlabel">
                  </rg-gauge-chart>
                  <p class="title2">Fulfilled</p>
                  </div>
                </div>
              </mat-card-content>
              
            </mat-card>
          </div>
          </div>        
      </div>
    </div>
  </div>